
import SashiDo from 'lib/SashiDo';

let CDNSites = null;

const CDNManager = {
  init(reload) {
    if(reload) {
      let promiseList = [];

      const SiteDataPromise = SashiDo.CDNServiceSitesData().then(({ results, error}) => {
        if(error) return null

        CDNSites = results;

        return CDNSites;
      });

      promiseList.push(SiteDataPromise);

      return Promise.all(promiseList).then(() => {
        return { CDNSites };
      });
    }

    return Promise.resolve({ CDNSites });
  },

  CDNServiceSitesData() {
    return Promise.resolve(CDNManager.init(!CDNSites));
  },

  CDNServiceCurrentSiteData(id) {
    return this.CDNServiceSitesData().then(({CDNSites}) => {
      let result;

      CDNSites.forEach((item) => {
        if(id === item.objectId) {
          result = item;
        }
      });

      return result;
    })
  },
};

export default CDNManager;

